const MONTH_KEYS = [
  'jan',
  'feb',
  'mar',
  'apr',
  'may',
  'jun',
  'jul',
  'aug',
  'sep',
  'oct',
  'nov',
  'dec',
]

export function formatReleaseDate(iso, t) {
  if (!iso) return ''
  const d = new Date(iso)
  return t('time:date_full', {
    day: d.getDate(),
    month: t(`time:months.${MONTH_KEYS[d.getMonth()]}`),
    year: d.getFullYear(),
  })
}
